module.exports = __webpack_public_path__ + "static/img/purple-file.bc78f1ec.png";